import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SendTaxFormEmailRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SendTaxFormEmailResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const sendTaxFormEmail = (request: SendTaxFormEmailRequest, options?: CashRequestOptions) =>
  post<SendTaxFormEmailRequest, SendTaxFormEmailResponse>('/2.0/cash/send-tax-form-email', request, {
    ...options,
    rejectOnError: true,
  })
